module.exports = __webpack_public_path__ + "static/media/Banner_4.70b257e7.jpg";